import React, { useRef, useState, useEffect } from 'react';
import { uploadFile }from "../Services/Service";
import { CustomLoader } from "../Services/CommonLibrary"
import History from './History';
import FileUploadTab from './FileUploadTab';
import FileUploadTabNew from './FileUploadTabNew';
import FileUploadText from './FileUploadText';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

function FileUploadNew() {
    const [key, setKey] = useState('text');
    const [loading, setLoading] = useState(false);

    const isTestUser= localStorage.getItem('isTestUser');
    const showUploadExcelButton = process.env.REACT_APP_SHOW_UPLOAD_EXCEL_BUTTON === 'true';
    console.log("showUploadExcelButton", process.env);
    const [reloadCounter, setReloadCounter] = useState(0);

  const handleReload = () => {
    setReloadCounter(reloadCounter + 1);
  };

    return (
        <>
            <section className='projects-section uploadtab'>
            <Tabs id="controlled-tab-example" activeKey={key} onSelect={(k) => setKey(k)} className="mb-1">
                {
                    showUploadExcelButton ?
                    <Tab eventKey="file" title="Upload Patient records using file .xlsx File">
                        <FileUploadTab onReload={handleReload} />
                    </Tab>
                    : null
                }
                <Tab eventKey="text" title="Add Patient records using Data">
                    <FileUploadText onReload={handleReload}/>
                </Tab>
                {/* { isTestUser == 'Y' ?
                     <Tab eventKey="file-new" title="Upload Patient records using file .xlsx File (New)">
                        <FileUploadTabNew onReload={handleReload} />
                    </Tab> : null
                } */}
            </Tabs>

            <hr className='line' />
                <History key={reloadCounter} /> 
            </section>
            
            { loading ? <CustomLoader /> : null }
        </>
    );
}
export default FileUploadNew;